import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    id: 0,
    fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
    fechaPago: moment(new Date()).format('YYYY-MM-DD'),
    bancoId: 0,
    banco: null,
    bancoNombre: null,
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    titular: '',
    titularCuit: '',
    sinNumero: false,
    serie: '',
    numero: 0,
    importe: 0,
    rowVersion: null,
    
    chequeTerceroDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_CHEQUE_TERCERO'(state, chequeTerceroId) {
        state.id = chequeTerceroId;
        state.fechaEmision = moment(new Date()).format('YYYY-MM-DD');
        state.fechaPago = moment(new Date()).format('YYYY-MM-DD');
        state.bancoId = 0;
        state.banco = null;
        state.bancoNombre = null;
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.titular = '';
        state.titularCuit = '';
        state.sinNumero= false;
        state.serie = '';
        state.numero = 0;
        state.importe = 0;
        state.rowVersion = null;
    },
    'SET_CHEQUE_TERCERO'(state, chequeTercero) {
        state.fechaEmision = moment(chequeTercero.fechaEmision).format('YYYY-MM-DD');
        state.fechaPago = moment(chequeTercero.fechaPago).format('YYYY-MM-DD');
        state.bancoId = (chequeTercero.banco) ? chequeTercero.banco.id : 0;
        state.banco = chequeTercero.banco;
        state.bancoNombre = (chequeTercero.banco) ? chequeTercero.banco.nombre.trim() : null;
        state.clienteId = (chequeTercero.cliente) ? chequeTercero.cliente.id : 0;
        state.cliente = chequeTercero.cliente;
        state.clienteNombre = (chequeTercero.cliente) ? chequeTercero.cliente.nombre.trim() : null;
        state.titular = chequeTercero.titular.trim();
        state.titularCuit = chequeTercero.titularCuit.trim();
        state.sinNumero= (/true/i).test(chequeTercero.sinNumero);
        state.serie = chequeTercero.serie.trim();
        state.numero = parseInt(chequeTercero.numero);
        state.importe = parseFloat(chequeTercero.importe);
        state.rowVersion = chequeTercero.rowVersion;
    },
    'SET_BANCO'(state, banco) {
        state.banco = banco;
        state.bancoId = banco ? banco.id : 0;
        state.bancoNombre = banco ? banco.nombre.trim() : null;
    },
    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;
        state.clienteId = cliente ? cliente.id : 0;
        state.clienteNombre = cliente ? cliente.nombre.trim() : null;
    },

    'INICIALIZAR_CHEQUE_TERCERO_DATOS' (state) {
        state.chequeTerceroDatos = [];
    },
    'SET_CHEQUE_TERCERO_DATOS' (state, params) {
        state.chequeTerceroDatos = params.chequeTerceroDatos;
    }
};

const getters = {
    getField,

    chequeTercero (state) {
        let chequeTercero = {
            fechaEmision: moment(state.fechaEmision).format('YYYY-MM-DD'),
            fechaPago: moment(state.fechaPago).format('YYYY-MM-DD'),
            bancoId: parseInt(state.bancoId),
            clienteId: parseInt(state.clienteId),
            titular: state.titular.toUpperCase().trim(),
            titularCuit: state.titularCuit.toUpperCase().trim(),
            sinNumero: (/true/i).test(state.sinNumero),
            serie: state.serie.toUpperCase().trim(),
            numero: parseInt(state.numero),
            importe: parseFloat(state.importe),
        }
        return chequeTercero;
    }
};

const actions = {
    inicializar ( { commit }, chequeTerceroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CHEQUE_TERCERO', chequeTerceroId);

            let getCheque = false;

            if (chequeTerceroId) {
                if (chequeTerceroId != 0) {
                    getCheque = true;
                }
            }

            if (getCheque) {
                apiAxios.get('chequesterceros/' + chequeTerceroId + '/abm' ) 
                    .then(res => {
                        commit('SET_CHEQUE_TERCERO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let serie = state.serie.toUpperCase().trim();
            let numero = parseInt(state.numero);
            let sinNumero = false;

            // if ((/true/i).test(state.sinNumero)) {
            //     serie = '';
            //     numero = 0;
            // }

            let chequeTercero = {
                fechaEmision: moment(state.fechaEmision).format('YYYY-MM-DD'),
                fechaPago: moment(state.fechaPago).format('YYYY-MM-DD'),
                bancoId: parseInt(state.bancoId),
                clienteId: parseInt(state.clienteId),
                titular: state.titular.toUpperCase().trim(),
                titularCuit: state.titularCuit.toUpperCase().trim(),
                // sinNumero: (/true/i).test(state.sinNumero),
                sinNumero,
                serie,
                numero,
                importe: parseFloat(state.importe),
            }

            let url = 'chequesterceros';
            if (state.id != 0) {
                chequeTercero.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, chequeTercero)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setBanco: ({commit}, banco) => {
        commit('SET_BANCO', banco);
    },
    setCliente: ({commit}, cliente) => {
        commit('SET_CLIENTE', cliente);
    },

    getChequeTerceroDatos ( { commit }, chequeTerceroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CHEQUE_TERCERO_DATOS');

            if (chequeTerceroId != 0) {
                apiAxios.get('chequesTerceros/' + chequeTerceroId ) 
                .then(res => {
                    let chequeTerceroDatos = [
                        { 'nombre': 'fechaEmision', 'campo': 'Fecha Emisión', 'valor': res.data.fechaEmision, 'formato': 'fecha' },
                        { 'nombre': 'fechaPago', 'campo': 'Fecha Pago', 'valor': res.data.fechaPago, 'formato': 'fecha' },
                        { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                        { 'nombre': 'titular', 'campo': 'Titular', 'valor': res.data.titular, 'formato': '' },
                        { 'nombre': 'titularCuit', 'campo': 'Cuit', 'valor': res.data.titularCuit, 'formato': 'cuit' },
                        { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                        // { 'nombre': 'serie', 'campo': 'Serie', 'valor': res.data.serie, 'formato': '' },
                        // { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.numero, 'formato': '' },
                        // { 'nombre': 'importe', 'campo': 'Importe', 'valor': res.data.importe, 'formato': 'moneda' },
                        // { 'nombre': 'caja', 'campo': 'Cartera', 'valor': res.data.caja ? 'Si' : 'No' , 'formato': '' },
                    ];
                    
                    if ((/true/i).test(res.data.sinNumero)) {
                        chequeTerceroDatos.push({ 'nombre': 'sinNumero', 'campo': 'Número', 'valor': 'Sin Número', 'formato': '' });
                    } else {
                        chequeTerceroDatos.push({ 'nombre': 'serie', 'campo': 'Serie', 'valor': res.data.serie, 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.numero, 'formato': '' });
                    }
                    chequeTerceroDatos.push({ 'nombre': 'importe', 'campo': 'Importe', 'valor': res.data.importe, 'formato': 'moneda' },
                        { 'nombre': 'caja', 'campo': 'Cartera', 'valor': res.data.caja ? 'Si' : 'No' , 'formato': '' });

                    let params = {
                        chequeTerceroDatos 
                    }
                    commit('SET_CHEQUE_TERCERO_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}